import { TextInput, Select } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { DatePickerInput } from "@mantine/dates";

export default function ColumnFilter({ column }) {

    const filterType = column.columnDef.filter;
    const columnValue = column?.getFilterValue()

    switch (filterType) {
        case "select":
            return (
                <Select
                    data={column.columnDef.filterOptions}
                    onChange={(value) => column.setFilterValue(value)}
                    searchable={true}
                    clearable
                    value={columnValue ?? ''}
                />
            )
        case "date":
            return (
                <DatePickerInput
                    locale="es"
                    type="range"
                    clearable
                    allowSingleDateInRange
                    value={columnValue ?? [null, null]}
                    onChange={(value) => column.setFilterValue(value)}
                />
            )
        default:
            return (
                <TextInput
                    leftSection={< IconSearch size={16} />}
                    type="text"
                    value={columnValue ?? ''}
                    onChange={(e) => {
                        column.setFilterValue(e.target.value.toUpperCase())
                    }}
                />
            )
    }
}